import MovimentosODS from '@/views/public/movimentos_ods'
import { DEFAULT_TITLE } from '../const'

export const movimentosODS = [
  {
    name: 'movimentos_ods',
    path: '/movimentos-ods',
    component: MovimentosODS,
    meta: {
      title: `${DEFAULT_TITLE} | Movimentos ODS`
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/public/movimentosODS.js